import React, { Component } from 'react';
import './footer.css'
import Share from '../share'

class Footer extends Component {

  clickRules = () => {
    window.ga('send', 'event', 'link', 'click', 'Rules');
  }

  render() {
    return (
      <div className="footer">
	      <div className="rules">
	        <a href="/rules.pdf" target="_blank" onClick={this.clickRules}>Полные правила</a>
	      </div>

	      <Share></Share>
	    </div>
    );
  }
}

export default Footer;